import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageFR() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Analyse Relationnelle IA | Détectez les schémas Toxiques et le Gaslighting" description="Découvrez si votre ex est le problème. Téléchargez vos discussions sur l'IA de ToxicDetector pour une analyse instantanée et confidentielle de la manipulation, du gaslighting et des signaux d'alarme. Démarrez l'analyse gratuite aujourd'hui." keywords="analyse relationnelle IA, détecter schémas toxiques, détecteur de gaslighting, ex toxique, vérificateur de manipulation, toxicité relationnelle, scanner de texte IA" canonical="https://toxicdetector.com/fr" language="fr" alternateUrls={alternateUrls} data-id="element-5927" />
      <GoogleTranslateWidget data-id="element-5928" />
      <PromoBanner data-id="element-5929" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5930">
        <Header data-id="element-5931" />
        <main data-id="element-5932">
          <HeroSection h1Override={<>
                Votre Cerveau Vous{' '}
                <span className="relative inline-block" data-id="element-5934">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-5935">
                    Ment
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-5936" />
                </span>
                {'. '}
                <br data-id="element-5937" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-5938">
                  Pas Notre IA.
                </span>
              </>} data-id="element-5933" />
          <TrustSection data-id="element-5939" />
          <FeaturesSection data-id="element-5940" />
          <GuaranteesSection data-id="element-5941" />
          <ToolsSection data-id="element-5942" />
          <ComparisonSection data-id="element-5943" />
          <PricingSection data-id="element-5944" />
          <FAQSection data-id="element-5945" />
          <CTASection data-id="element-5946" />
        </main>
        <Footer data-id="element-5947" />
      </div>
    </>;
}